import { API_URLS } from '../../../constants/urls/api-urls';
import { getData, postData } from '../../../utils/fetch-api-util';

export interface ExternalToolResponse {
  total: number;
  data: ExternalToolRecord[];
  take?: number;
  page?: number;
}

export interface ExternalToolRecord {
  id: string;
  name: string | null;
  toolUrl: string | null;
}

export interface ExternalToolParams {
  take?: number;
  page?: number;
}

export interface ExternalToolPayload {
  id?: string;
  name?: string | null;
  toolUrl?: string | null;
}

export const getExternalToolRepository = async (data: ExternalToolParams): Promise<ExternalToolResponse> => {
  const response = await getData<ExternalToolParams, ExternalToolResponse>(API_URLS.EXTERNAL_TOOLS, data);
  return response.data;
};

export const postSaveExternalToolRepository = async (payload: ExternalToolPayload): Promise<ExternalToolResponse> => {
  const response = await postData<ExternalToolPayload, any>(API_URLS.EXTERNAL_TOOLS_SAVE, payload);
  return response.data;
};

export const postDeleteExternalToolRepository = async (payload: ExternalToolPayload): Promise<ExternalToolResponse> => {
  const response = await postData<ExternalToolPayload, any>(API_URLS.EXTERNAL_TOOLS_DELETE, payload);
  return response.data;
};
